import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { ONBOARDING_PATH } from '../../main/onboarding/Onbording';
import { isUserProfileComplete } from '../../utils/validation';
import { Aggrements, UserState } from '../redux/types';
import { InvestorStatus, UserStatus } from './Status';

export const getRedirectUrlAfterLogin = (user: UserState, url_key: string | undefined) => {
    const nda: Aggrements | undefined = user.investor?.agreements?.find((a) => a.agreementType === 'NDA');
    if (!user.user || !isUserProfileComplete(user?.user?.userProfile)) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.BASIC_PROFILE}`;
    } else if (user.user && user.user.status === UserStatus.pendingActivation) {
        return HEADERMENU_PATH.accountActivationWithOtp;
    } else if (!user.investor || !user.investor.accreditation) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITATION}`;
    } else if (
        !user.investor ||
        !user.investor.profile ||
        (user.investor.investorType === 'Individual Accredited' && !user.investor.profile.employmentStatus) ||
        ((user.investor.investorType === 'Institutional' || user.investor.investorType === 'Corporate Accredited') &&
            !user.investor.profile.companyName)
    ) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTOR_PROFILE}`;
    } else if (!nda || user.investor.status.profile === InvestorStatus.PendingNDA) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.NDA}`;
    } else {
        if (url_key) {
            return url_key;
        } else {
            return HEADERMENU_PATH.deals;
        }
    }
};

export const isNonAuthenticatedUrl = (path: string) => {
    if (
        path === HEADERMENU_PATH.login ||
        path === HEADERMENU_PATH.signUp ||
        path === HEADERMENU_PATH.signUpSuccess ||
        path === HEADERMENU_PATH.accountActivation ||
        path === HEADERMENU_PATH.activateAccountAndSetPassword ||
        path === HEADERMENU_PATH.forgotPassword ||
        path === HEADERMENU_PATH.forgotPasswordMessage ||
        path === HEADERMENU_PATH.resetPassword ||
        path.includes(HEADERMENU_PATH.referralSignUp) ||
        path === HEADERMENU_PATH.oauth2 ||
        path === HEADERMENU_PATH.accountActivationWithOtp
    ) {
        return true;
    }

    return false;
};

export const checkOnbordingFlow = (user: UserState) => {
    const nda: Aggrements | undefined = user.investor?.agreements?.find((a) => a.agreementType === 'NDA');
    if (!user.user || !isUserProfileComplete(user?.user?.userProfile)) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.BASIC_PROFILE}`;
    } else if (user.user.status === UserStatus.pendingActivation) {
        return `${HEADERMENU_PATH.accountActivationWithOtp}`;
    } else if (!user.investor || !user.investor.accreditation) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITATION}`;
    } else if (
        !user.investor ||
        !user.investor.profile ||
        (user.investor.investorType === 'Individual Accredited' && !user.investor.profile.employmentStatus) ||
        ((user.investor.investorType === 'Institutional' || user.investor.investorType === 'Corporate Accredited') &&
            !user.investor.profile.companyName)
    ) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTOR_PROFILE}`;
    } else if (!nda || user.investor.status.profile === InvestorStatus.PendingNDA) {
        return `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.NDA}`;
    }
    return undefined;
};
